import { useQueryContext } from '@sierralabs/query-ui';
import { getStateNodeByStatus, useTaskWorkflow } from '@sierralabs/workflow-ui';
import { useKanbanBoard } from '../../common/kanban-board/hooks/useKanbanBoard';
import { getQueryValue } from '../component/useQueryDisplayValue';
export function useSiteKanbanBoard(component) {
    const { queries } = useQueryContext();
    const cProps = component.props || {};
    const workflow = useTaskWorkflow({ workflowId: cProps.workflowId });
    const componentColumns = cProps.columns || [];
    const columns = componentColumns.map(column => {
        var _a;
        const stateNode = getStateNodeByStatus(column.workflowPath, workflow);
        const boardColumn = {
            id: column.id,
            name: column.name || '',
            state: stateNode && {
                name: stateNode.name,
                color: (_a = stateNode.meta) === null || _a === void 0 ? void 0 : _a.color,
                events: stateNode.events
            }
        };
        return boardColumn;
    });
    const getColumnQuery = (columnId) => {
        const column = componentColumns.find(column => column.id === columnId);
        const queryId = column === null || column === void 0 ? void 0 : column.queryId;
        return queryId ? queries.find(query => query.id === queryId) : undefined;
    };
    const createItem = (columnId, data) => {
        // get configuration for column
        const column = componentColumns.find(column => column.id === columnId);
        const fields = (column === null || column === void 0 ? void 0 : column.itemFields) || {};
        const query = getColumnQuery(columnId);
        const getValue = (queryField) => {
            var _a;
            return query && queryField
                ? (_a = getQueryValue(data, query, queryField)) !== null && _a !== void 0 ? _a : ''
                : '';
        };
        const taskId = getValue(fields.taskId);
        const assignee = {
            firstName: getValue(fields.firstName),
            lastName: getValue(fields.lastName)
        };
        const item = {
            data,
            columnId,
            // unique id, item.columnId gets changed later when
            // dragging / dropping items into different columns
            id: `${getValue(fields.id)}-${taskId}-${columnId}`,
            taskId,
            title: getValue(fields.title),
            description: getValue(fields.description),
            status: getValue(fields.status),
            deleted: !!getValue(fields.deleted),
            // allow when either one exists
            assignee: assignee.firstName || assignee.lastName ? assignee : undefined
        };
        return item;
    };
    return useKanbanBoard({ columns, createItem });
}
//# sourceMappingURL=useSiteKanbanBoard.js.map